export default defineI18nConfig(() => {
  return {
    datetimeFormats: {
      en: {
        fullDate: {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        },
        shortDate: {
          month: '2-digit',
          day: '2-digit'
        },
        time: {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        }
      },
      fa: {
        fullDate: {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        },
        shortDate: {
          month: '2-digit',
          day: '2-digit'
        },
        time: {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        }
      }
    }
  }
})
